
<template>
    <svg xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        :aria-labelledby="iconName"
        :viewBox="viewBox"
        role="presentation">

        <title id="iconName" lang="fr">{{ $l10n.__(`${iconName} icon`) }}</title>

        <g :fill="iconColor">
            <slot />
        </g>
    </svg>
</template>

<script>
// ref: https://fr.vuejs.org/v2/cookbook/editable-svg-icons.html
export default {
    props: {
        iconName: {
            type: String,
            default: 'svg'
        },
        width: {
            type: [Number, String],
            default: 20
        },
        height: {
            type: [Number, String],
            default: 20
        },
        viewBox: {
            type: String,
            default: '0 0 512 512'
        },
        iconColor: {
            type: String,
            default: 'currentColor'
        }
    }
}
</script>
